import React, { Component } from "react";
import launch from '../img/launch_site.jpg'
import strike from '../img/strike.jpg'
import strike2 from '../img/strike2.jpg'
import strike3 from '../img/strike3.jpg'
import strike4 from '../img/strike4.jpg'
import strike5 from '../img/strike5.jpg'
import strike6 from '../img/strike6.jpg'
import launch2 from '../img/launch2.jpg'
import engine from '../img/engine.jpg'

import $ from 'jquery';

$(document).ready(function() {
    
  /* Every time the window is scrolled ... */
  $(window).scroll( function(){
  
      /* Check the location of each desired element */
      $('.hideme').each( function(i){
          
          var bottom_of_object = $(this).offset().top + $(this).outerHeight();
          var bottom_of_window = $(window).scrollTop() + $(window).height();
          
          /* If the object is completely visible in the window, fade it it */
          if( bottom_of_window > bottom_of_object ){
              
              $(this).animate({'opacity':'1'},2000);
                  
          }
          
      }); 
  
  });
  
});

class Images extends Component {
  render() {
    return (
<div>
<h2 class="pynchonquote ml-4">
          A screaming comes <br></br>
          across the sky...
        </h2>
<div class="container my-4 ">

<h2 class="font-weight-bold">Archived images</h2>
<p>Results of the strikes</p>
<hr></hr>


<div class="row ">
    <div class="col-md-12">
      <div class="mdb-lightbox no-margin">
        <figure class="col-md-4 flex hideme">
          <a href={launch} data-size="1600x1067">
            <img src={launch} class="img-fluid" alt="launch"/>
          </a>
        </figure>
        <figure class="col-md-4 flex hideme">
          <a href={strike} data-size="1600x1067">
            <img src={strike}class="img-fluid" />
          </a>
        </figure>
        <figure class="col-md-4 flex">
          <a href={strike2} data-size="1600x1067">
            <img src={strike2} class="img-fluid" />
          </a>
        </figure>
        <figure class="col-md-4 flex">
          <a href={launch2} data-size="1600x1067">
            <img src={launch2} class="img-fluid" />
          </a>
        </figure>
        <figure class="col-md-4 flex">
          <a href={strike3} data-size="1600x1067">
            <img src={strike3} class="img-fluid" />
          </a>
        </figure>
        <figure class="col-md-4 flex">
          <a href={strike4} data-size="1600x1067">
            <img src={strike4} class="img-fluid" />
          </a>
        </figure>
        <figure class="col-md-4 flex">
          <a href={strike5} data-size="1600x1067">
            <img src={strike5} class="img-fluid" alt="Hughes Mansions in Vallance Road after a direct hit by 
            Hitler's last attack on London, just six weeks before the end of the war in Europe"/>
          </a>
        </figure>
        <figure class="col-md-4 flex hideme">
          <a href={engine}data-size="1600x1067">
            <img src={engine} class="img-fluid" />
          </a>
        </figure>
        <figure class="col-md-4 flex">
          <a href={strike6} data-size="1600x1067">
            <img src={strike6} class="img-fluid" />
          </a>
        </figure>
      </div>
    </div>
  </div>
</div>
</div>
    );
  }
}


export default Images;